// Notification errorMessage can be a plain string ("Bad Request") or a
// serialized error object from Inngest, e.g.
// {"error":{"error":"InngestErrTimeoutTooLong: ...","name":"...","message":"..."}}.
// Pull out the most human-readable message so the drawer doesn't render a raw
// JSON blob.
export const formatNotificationError = (raw?: string | null): string => {
  if (!raw) return 'Unknown error'

  const trimmed = raw.trim()
  if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
    return trimmed
  }

  try {
    const parsed = JSON.parse(trimmed)
    return extractMessage(parsed) ?? trimmed
  } catch {
    return trimmed
  }
}

const extractMessage = (value: unknown): string | null => {
  if (typeof value === 'string') {
    return value.trim() || null
  }
  if (!value || typeof value !== 'object') {
    return null
  }
  const obj = value as Record<string, unknown>
  return (
    extractMessage(obj.message) ??
    extractMessage(obj.error) ??
    extractMessage(obj.reason) ??
    null
  )
}
